export default __webpack_public_path__ + "static/media/login-background.470bac74.svg";